import { getChannelId } from "@/apiUtils/commonUtils";
import { Locale, NextOptions, TypeFetchCache } from "../../../common/lib/types";
import HttpClient from "../../HttpClient";

class PublicSaleorClient extends HttpClient {
  apiPathname: string = "/graphql/";
  cache: TypeFetchCache = "no-store";
  channel: string = "";

  constructor() {
    const graphqlUrl: string = process.env.NEXT_PUBLIC_API_HOST || "";

    if (!graphqlUrl) {
      throw new Error("Saleor API URL is required but not found in environment variables");
    }
    super(graphqlUrl, "");
  }

  private setHeadersWithCorsHandling(headers: Record<string, string>): void {
    const accessToken = (this as any).accessToken;

    if (accessToken) {
      headers["Authorization"] = `Bearer ${accessToken}`;
    }
  }

  async init(locale?: Locale, token?: string) {
    if (token) {
      this.setAccessToken(token);
    }
    if (locale) {
      this.setLocale(locale);
      const channel = getChannelId(locale) || "";
      this.channel = channel;
    }
  }

  async post<T>(
    query: string,
    variables: any,
    cache: TypeFetchCache,
    next?: NextOptions,
  ): Promise<T> {
    const body = {
      query: query.toString(),
      ...(variables && { variables }),
    };

    const url = new URL(this.apiPathname, (this as any).baseUrl);
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    this.setHeadersWithCorsHandling(headers);

    const options: RequestInit = {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    };

    return (this as any).performFetch(url.toString(), options, cache, next);
  }

  async postForm<T>(
    query: string,
    variables: any,
    formData: FormData,
    operationName: string,
  ): Promise<T> {
    formData.append(
      "operations",
      JSON.stringify({
        operationName,
        variables: {
          ...variables,
        },
        query: query.toString(),
      }),
    );
    return super.postFormData(this.apiPathname, formData);
  }
}

export default PublicSaleorClient;
